const TermsBody = () => {
  return (
    <section className="flex flex-col  items-center">
      <div className="flex flex-col my-10 gap-5 p-3 md:p-5 lg:p-10 max-w-[80rem] w-full text-[#667085] text-[1.1rem] font-[500]">
        <div className="text-4xl font-[600] mx-auto text-[#34B3EB]">
          Terms of Service
        </div>
        <div className="text-2xl font-[600]">
          Please read these Terms of Service carefully before using Bible
          Compass mobile applicatonn
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          Acceptance of Terms
        </div>
        <div className="">
          By downloading, installing, or using the App, you agree to be bound by
          these Terms of Servicen If you do not agree with any of these terms,
          please do not use the App
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">License</div>
        <div className="">
          Bible Compass App grants you a limited, non-exclusive,
          non-transferable, revocable license to use the App for personal,
          non-commercial purposes in accordance with these Terms
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">Privacy Policy</div>
        <div className="">
          Your privacy is important to us Please refer to our Privacy Policy
          [link to Privacy Policy] for informaton on how we collect, use, and
          protect your personal data
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          Intellectual Property
        </div>
        <div className="">
          The App and its original content, features, and functonality are owned
          by Bible Compass App and are protected by international copyright,
          trademark, patent, trade secret, and other intellectual property laws
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">
          Limitation of Liaiility
        </div>
        <div className="">
          In no event shall Bible Compass App be liable for any direct,
          indirect, incidental, special, or consequental damages arising out of
          or in any way connected with the use of the App
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">Termination</div>
        <div className="">
          We may terminate or suspend your access to the App immediately,
          without prior notce or liability, for any reason whatsoever, including
          without limitaton if you breach these Terms and conditions
        </div>
        <div className="text-2xl font-[600] text-[#34B3EB]">Governing Laws</div>
        <div className="">
          The App is protected by the copyright laws of Nigeria, Internatonal
          treates and Conventons and Bible Compass App retains all rights, title
          and interest in and to the App including intellectual propertes
          associated with the App
        </div>
      </div>
    </section>
  );
};

export default TermsBody;
